import { MessageCircle } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";

export const waLink = (message) =>
  `https://wa.me/34624544020?text=${encodeURIComponent(message)}`;

export default function FloatingWhatsApp() {
  const { t } = useLanguage();

  return (
    <a
      href={waLink(t.contacto.waMessage)}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float"
      aria-label={t.contacto.whatsapp}
      className="fixed bottom-6 right-6 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-xl shadow-forest-950/30 transition-transform hover:scale-105"
    >
      <MessageCircle size={26} />
    </a>
  );
}
